<h4 mat-dialog-title>{{data.text}}</h4>
@if (data.extraText) {
  <p>{{data.extraText}}</p>
}
<div mat-dialog-actions>
  <button type="button" mat-raised-button color="primary" (click)="onClose()" cdkFocusInitial>Fechar</button>
</div>
